import NavBar from '@/components/NavBar/NavBar.vue';
import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { LOGOUT } from "@/utils/logout.js";

export default {
  name: 'SystemCommunications',
  mixins: [LOGOUT],

  components: {
    NavBar
  },
  data: () => ({
    read_system_comms: [],
    unread_system_comms: [],
    all_system_comms: [],
    activeTab: 'unread',
    quill: null,
    editingCommId: null,
    isSystemAdmin: false,
    showCreateModal: false,
    editorWordCount: 0,
  }),
  computed: {
    isSaveDisabled() {
      return this.editorWordCount === 0;
    }
  },
  methods: {
    formatDateTime(date) {
      if (!date) return "N/A";
      const d = new Date(date);
      if (isNaN(d.getTime())) return "N/A";
      return d.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
    },
    setIsSystemAdmin() {
      const role = this.$store.getters.get_user_role;
      this.isSystemAdmin = role === 'SystemAdmin';

      if (this.isSystemAdmin) {
        this.activeTab = 'all';
      }
    },

    get_system_communications() {
      const TOKEN = localStorage.getItem('token');
      const GET_SYSTEM_COMMUNICATIONS_API = `${API_BASE_URL}/verify_api/system_management_api/get_system_communications_api/`;

      $.ajax({
        url: GET_SYSTEM_COMMUNICATIONS_API,
        method: 'GET',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        success: (response) => {
          if (response.redirect) {
            this.logout();
            return;
          }
          this.read_system_comms = response.read;
          this.unread_system_comms = response.unread;
          this.all_system_comms = response.all;
        },
        error: () => {
          Swal.fire('Error', 'Could not fetch system communications.', 'error');
        }
      });
    },

    markAsRead(commId) {
      const TOKEN = localStorage.getItem('token');
      const MARK_AS_READ_API = `${API_BASE_URL}/verify_api/system_management_api/read_system_communication_api/`;

      $.ajax({
        url: MARK_AS_READ_API,
        method: 'POST',
        contentType: 'application/json',
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify({ system_communication: commId }),
        success: () => {
          const idx = this.unread_system_comms.findIndex(c => c.id === commId);
          if (idx !== -1) {
            const comm = this.unread_system_comms.splice(idx, 1)[0];
            this.read_system_comms.unshift(comm);
          }
        },
        error: () => {
          Swal.fire('Error', 'Could not mark as read.', 'error');
        }
      });
    },

    openCreateModal() {
      this.showCreateModal = true;
      this.$nextTick(() => {
        this.initQuill();
      });
    },

    closeCreateModal() {
      this.showCreateModal = false;
      this.editorWordCount = 0;
      this.editingCommId = null;
    },

    initQuill() {
      const editorEl = document.getElementById('quill-editor');
      if (editorEl) {
        this.quill = new window.Quill(editorEl, {
          theme: 'snow'
        });

        // Update word count on text change
        this.quill.on('text-change', () => {
          const text = this.quill.getText().trim();
          this.editorWordCount = text.length > 0 ? text.split(/\s+/).filter(word => word.length > 0).length : 0;
        });

        // Initialize word count
        this.updateWordCount();
      }
    },

    updateWordCount() {
      if (this.quill) {
        const text = this.quill.getText().trim();
        this.editorWordCount = text.length > 0 ? text.split(/\s+/).filter(word => word.length > 0).length : 0;
      }
    },

    editCommunication(comm) {
      this.editingCommId = comm.id;
      this.openCreateModal();
      this.$nextTick(() => {
        if (this.quill) {
          this.quill.root.innerHTML = comm.message;
          this.updateWordCount();
        }
      });
    },

    saveCommunication() {
      const TOKEN = localStorage.getItem('token');
      const message = this.quill ? this.quill.root.innerHTML : '';

      if (!message.trim()) {
        Swal.fire('Error', 'Message cannot be empty.', 'error');
        return;
      }

      if (this.editingCommId) {
        // Update existing communication
        const UPDATE_COMM_API = `${API_BASE_URL}/verify_api/system_management_api/update_system_communication_api/`;

        $.ajax({
          url: UPDATE_COMM_API,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          data: JSON.stringify({ system_communication: this.editingCommId, message }),
          success: () => {
            this.get_system_communications();

            this.quill.setContents([]);
            this.closeCreateModal();
          },
          error: () => {
            Swal.fire('Error', 'Could not update communication.', 'error');
          }
        });

      } else {
        // Create new communication
        const CREATE_COMM_API = `${API_BASE_URL}/verify_api/system_management_api/create_system_communication_api/`;

        $.ajax({
          url: CREATE_COMM_API,
          method: 'POST',
          contentType: 'application/json',
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          data: JSON.stringify({ message }),
          success: () => {
            this.get_system_communications();
            
            this.quill.setContents([]);
            this.closeCreateModal();
          },
          error: () => {
            Swal.fire('Error', 'Could not save communication.', 'error');
          }
        });
      }
    },
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }

    this.setIsSystemAdmin();
    this.get_system_communications();
  },
};
